import type { FC } from 'react';

type IconProps = {
    className?: string;
};

/**
 * フィルターアイコン
 */
export const FilterIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M3 4.6C3 4.04772 3.44772 3.6 4 3.6H20C20.5523 3.6 21 4.04772 21 4.6V6.33726C21 6.58185 20.9105 6.81801 20.7485 7.00163L14.7515 13.7984C14.5895 13.982 14.5 14.2181 14.5 14.4627V19.4C14.5 19.9523 14.0523 20.4 13.5 20.4H10.5C9.94772 20.4 9.5 19.9523 9.5 19.4V14.4627C9.5 14.2181 9.41046 13.982 9.25148 13.7984L3.25148 7.00163C3.08954 6.81801 3 6.58185 3 6.33726V4.6Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
